/**
 * Login UI must not echo stack traces, file paths, or other internal diagnostics (see API error middleware).
 */

const MAX_LOGIN_MESSAGE_LENGTH = 200;

function looksLikeStackOrInternalDiagnostics(text: string): boolean {
  if (text.length > MAX_LOGIN_MESSAGE_LENGTH) {
    return true;
  }
  const lineCount = (text.match(/\n/g) ?? []).length;
  if (lineCount > 3) {
    return true;
  }
  if (/\bat\s+[\w.$/]+\s*\(/i.test(text)) {
    return true;
  }
  if (/node_modules[/\\]/i.test(text)) {
    return true;
  }
  if (/\.(ts|tsx|js|mjs|cjs):\d{1,5}\b/i.test(text)) {
    return true;
  }
  if (/\n\s*\^\s*$/.test(text)) {
    return true;
  }
  if (/^\s*Error:\s*\w+/m.test(text)) {
    return true;
  }
  if (/\b(select|insert|update|delete|drop|alter)\b[\s\S]{0,80}\b(from|into|table|where|values)\b/i.test(text)) {
    return true;
  }
  if (/\b(NullPointerException|IntegrityError|UniqueViolation|OperationalError|ProgrammingError|SQLException)\b/i.test(text)) {
    return true;
  }
  if (/\b(psycopg2|sqlalchemy|django\.db|sequelize|typeorm)\b/i.test(text)) {
    return true;
  }
  return false;
}

/** Returns the string if it is safe to show on the login form; otherwise null (caller uses a generic message). */
export function sanitizeLoginErrorMessage(text: string): string | null {
  const trimmed = text.trim();
  if (!trimmed) {
    return null;
  }
  if (looksLikeStackOrInternalDiagnostics(trimmed)) {
    return null;
  }
  return trimmed;
}
